import { Box, Text, useBreakpointValue } from "@chakra-ui/react";
import { bodyBGColor, headingPrimaryFont, headingSecondaryFont, primaryColor } from "../config";
import Post from "./ModalPost";
import CarouselCardPost from "./Carousels/CarouselCardPost";
import DividerAbsoluteCenter from "./DividerAbsoluteCenter";
import { useEffect, useState } from "react";
import { CarouselCardDetails_t } from "./Carousels/CarouselCard";
import { useNavigate } from "react-router-dom";

interface BlogPostProps {
    post: CarouselCardDetails_t
    title?: string
    id?: string
}

export default function BlogPost({ post, title="", id=undefined }: BlogPostProps) {
    const urlParam = new URLSearchParams(window.location.search);
    const imageHeight = useBreakpointValue({ base: "15rem", md: "20rem" }, { ssr: false })
    const [isOpen, setIsOpen] = useState(true);
    const navigate = useNavigate();
    const postId = id? id : post.groupId
    function onClose() {
        setIsOpen(false)
        navigate(`/blog#${post.groupId}`)
    }

    const [modelPost, setModelPost] = useState<CarouselCardDetails_t | undefined>(undefined);

    useEffect(() => {
        if (urlParam.get("id") && !modelPost) {
            const redirectedPost = post.groupId + "_" + post.id == urlParam.get("id")
            setModelPost(redirectedPost ? post : undefined)
        }
    }, [modelPost])

    function handleClick(id: string) {
        setIsOpen(true)
        setModelPost(post)
    }

    return (
        <Box id={ postId }>
            <DividerAbsoluteCenter bg={bodyBGColor} dividerBorderColor={primaryColor} >
                {title && <Text fontSize={{ base: headingSecondaryFont, lg: headingPrimaryFont }} textAlign={"center"}
                    color={primaryColor}
                >{title}</Text>}
            </DividerAbsoluteCenter>
            <Box >
                <br />
                <CarouselCardPost card={post} imageHeight={imageHeight!} footerButtonHandleClick={handleClick} />
                {modelPost
                    && <Post card={modelPost}
                        isOpen={isOpen}
                        onClose={onClose}
                    />}
            </Box>
        </Box>
    )
}